export function isProdEnvironment(url) {
  return (
    (url.includes("grubhub") &&
      !isSandBoxEnvironment(url) &&
      !isPreprod(url)) ||
    url.includes("prod-local")
  );
}

export function isPreprod(url) {
  return (
    /\bpp\b/.test(url) || url.includes("preprod") || url.includes("ghbeta")
  );
}

export function isSandBoxEnvironment(url) {
  return url.includes("bento");
}

export function isDevEnvironment(url) {
  return isLocalEnvironment(url) || url.includes("ghbeta");
}

export function isLocalEnvironment(url) {
  return (
    url.includes("local") ||
    url.includes("host.docker.internal") ||
    /^[0-9.]+/g.test(url)
  );
}



// WEBPACK FOOTER //
// ./client/app/common/api-util.js